import { render, staticRenderFns } from "./reviewWorkbenchPage.vue?vue&type=template&id=37fbfc02&scoped=true"
import script from "./reviewWorkbenchPage.vue?vue&type=script&lang=js"
export * from "./reviewWorkbenchPage.vue?vue&type=script&lang=js"
import style0 from "./reviewWorkbenchPage.vue?vue&type=style&index=0&id=37fbfc02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37fbfc02",
  null
  
)

export default component.exports